<template>
  <form @click.prevent="emitValues()" ref="form">
    <div class="row">
      <div class="col-md-3">
        <div class="select">
          <select class="select-text"
            @blur="$v.formValues.transportVehicle.$touch()" :class="{ invalid: $v.formValues.transportVehicle.$error }"
            v-model="formValues.transportVehicle">

            <option v-for="item in VehicleItems" :value="item.key" :key="item.key">
              {{ item.value }}
            </option>
          </select>
          <p class="text-danger" v-if="
            !$v.formValues.transportVehicle.required &&
            $v.formValues.transportVehicle.$dirty
          ">
            لطفا وسیله سفر را انتخاب نمائید
          </p>
         
          <label class="select-label">وسیله سفر</label>

        </div>
      </div>

      <div class="col-md-3">
        <div class="form-group inputContainer">
          <label>تاریخ سفر رفت</label>
          <div class="icon-position">
            <i class="icon_calendar icon"></i>
          </div>
          <input type="text" class="form-control" v-datepicker="{ maxDate: now }"
            :value="onConvertDate(formValues.leaveDate)" @change="formValues.leaveDate = $event.detail.GregorianDate"
            @blur="$v.formValues.leaveDate.$touch()" :class="{ invalid: $v.formValues.leaveDate.$error }"
            disabled="true" />
          <p class="text-danger" v-if="
            !$v.formValues.leaveDate.required &&
            $v.formValues.leaveDate.$dirty
          ">
            تاریخ صحیح را وارد کنید
          </p>
        </div>
      </div>

      <div class="col-md-3">
        <div class="form-group inputContainer">
          <label>تاریخ سفر برگشت</label>
          <div class="icon-position">
            <i class="icon_calendar icon"></i>
          </div>
          <input type="text" class="form-control" v-datepicker="{ maxDate: now }"
            :value="onConvertDate(formValues.returnDate)" @change="formValues.returnDate = $event.detail.GregorianDate"
            @blur="$v.formValues.returnDate.$touch()" :class="{ invalid: $v.formValues.returnDate.$error }"
            disabled="true" />
          <p class="text-danger" v-if="
            !$v.formValues.returnDate.required &&
            $v.formValues.returnDate.$dirty
          ">
            تاریخ صحیح را وارد کنید
          </p>
        </div>
      </div>

      <div class="col-md-3">
        <label>ساعت سفر رفت</label>
        <div class="form-group">
          <date-picker class="time-picker" color="#00C3E1" type="time" @blur="$v.formValues.leaveTime.$touch()" v-model="formValues.leaveTime" :class="{ invalid: $v.formValues.leaveTime.$error }"
            :minute-interval="5" />

          <!-- <input class="form-control" type="time" v-model="formValues.leaveTime" @blur="$v.formValues.leaveTime.$touch()"
            :class="{invalid:$v.formValues.leaveTime.$error}" /> -->

          <!-- <p
              class="text-danger"
              v-if="!$v.formValues.leaveTime.required && $v.formValues.leaveTime.$dirty"
            >ساعت سفر رفت را وارد کنید</p> -->
        </div>
      </div>

      <div class="col-md-4">
        <label>ساعت سفر برگشت</label>
        <div class="form-group">
          <!-- <input class="form-control" type="time" v-model="formValues.returnTime" @blur="$v.formValues.returnTime.$touch()"
            :class="{invalid:$v.formValues.returnTime.$error}" /> -->

                <date-picker class="time-picker" color="#00C3E1" type="time"  @blur="$v.formValues.returnTime.$touch()" v-model="formValues.returnTime" :class="{ invalid: $v.formValues.returnTime.$error }"
            :minute-interval="5" />
          <!-- <p
              class="text-danger"
              v-if="!$v.formValues.returnTime.required && $v.formValues.returnTime.$dirty"
            >ساعت سفر برگشت را وارد کنید</p> -->
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group" sm="10">
          <label>اطلاعات سفر رفت </label>
          <textarea class="form-control" placeholder="مشخصات پرواز رفت,شماره پرواز,نام ایرلاین"
            v-model="formValues.leaveDescription" @blur="$v.formValues.leaveDescription.$touch()"
            :class="{ invalid: $v.formValues.leaveDescription.$error }" />
          <p class="text-danger" v-if="
            !$v.formValues.leaveDescription.required &&
            $v.formValues.leaveDescription.$dirty
          ">
            اطلاعات سفر رفت را وارد کنید
          </p>

          <p class="text-danger" v-if="!$v.formValues.leaveDescription.maxLength">
            بیشتر از 50 کاراکتر مجاز نیست
          </p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group">
          <label>اطلاعات سفر برگشت </label>
          <textarea v-model="formValues.returnDescription" class="form-control"
            placeholder="مشخصات پرواز رفت,شماره پرواز,نام ایرلاین" @blur="$v.formValues.returnDescription.$touch()"
            :class="{ invalid: $v.formValues.returnDescription.$error }" />
          <p class="text-danger" v-if="
            !$v.formValues.returnDescription.required &&
            $v.formValues.returnDescription.$dirty
          ">
            اطلاعات سفر برگشت را وارد کنید
          </p>

          <p class="text-danger" v-if="!$v.formValues.returnDescription.maxLength">
            بیشتر از 50 کاراکتر مجاز نیست
          </p>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import {
  required,
  minLength,
  maxLength,
  email,
} from "vuelidate/lib/validators";
// import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import momentjalaali from "moment-jalaali";
import moment from "moment";

// import datePicker, { PersianDate } from "@alireza-ab/vue-persian-datepicker";

export default {
  props: {
    checkValid: {
      type: Boolean,
      default: true,
    },
    entriedForm: {
      type: Object,
    },
  },
  components: {
  },
  data: () => ({
    params: {},
    formValues: {
      transportVehicle: "",
      leaveDate: "",
      returnDate: "",
      leaveTime: "",
      returnTime: "",
      leaveDescription: "",
      returnDescription: "",
    },

    VehicleItems: [
      { key: 1, value: "هواپیما" },
      // { key: 2, value: "قطار" },
    ],
  }),
  validations: {
    formValues: {
      transportVehicle: { required },
      leaveDate: { required },
      returnDate: { required },
      leaveTime: {},
      returnTime: {},
      leaveDescription: { required, maxLength: maxLength(50) },
      returnDescription: { required, maxLength: maxLength(50) },
    },
  },

  created() {
    const today = new Date();

    this.params = this.$route.query;
    var leaveDate = "";

    if (this.entriedForm.leaveDate !== "") {
      this.entriedForm.leaveDate = momentjalaali(
        this.entriedForm.leaveDate,
        "jYYYY/jMM/jDD"
      ).format("YYYY/MM/DD");
    } else {
      this.entriedForm.leaveDate = moment(this.params.startDate).format(
        "YYYY/MM/DD"
      );
      // leaveDate = new Date().setDate(new Date(this.params.startDate).getDate());
    }

    var returnDate = "";
    if (this.entriedForm.returnDate !== "") {
      this.entriedForm.returnDate = momentjalaali(
        this.entriedForm.returnDate,
        "jYYYY/jMM/jDD"
      ).format("YYYY/MM/DD");
    } else {
      this.entriedForm.returnDate = moment(this.params.endDate).format(
        "YYYY/MM/DD"
      );
      // returnDate = new Date().setDate(new Date(this.params.endDate).getDate());
    }

    var leaveTime = today.getHours() + ":" + "00";
    if (this.entriedForm.leaveTime !== "") {
      leaveTime = this.entriedForm.leaveTime;
    }
    var returnTime = today.getHours() + ":" + "00";
    if (this.entriedForm.returnTime !== "") {
      returnTime = this.entriedForm.returnTime;
    }
    this.formValues = {
      transportVehicle: this.entriedForm.transportVehicle,
      leaveDate: this.entriedForm.leaveDate,
      returnDate: this.entriedForm.returnDate,
      leaveTime: leaveTime,
      returnTime: returnTime,
      leaveDescription: this.entriedForm.leaveDescription,
      returnDescription: this.entriedForm.returnDescription,
    };
    // this.formValues = this.entriedForm;
  },

  watch: {
    immediate: true,
    deep: true,
    checkValid: function (val) {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit("isValid", true);
      } else {
        this.$emit("isValid", false);
      }
    },
  },
  computed: {
    onEntriedForm() {
      return (this.entriedForm = this.entriedForm);
    },
  },
  methods: {
    onConvertDate(date) {
      if (date === "0001-01-01T00:00:00") return "";
      if (!momentjalaali(date).isValid()) return "";
      const pdate = momentjalaali(date).format("jYYYY/jMM/jDD");
      return pdate;
    },

    selectReturnDate(date) {
      let p = new PersianDate();

      this.formValues.returnDate = p
        .parse(date.d.year, date.d.month, date.d.date)
        .toString();
    },
    selectLeaveDate(date) {
      let p = new PersianDate();

      this.formValues.leaveDate = p
        .parse(date.d.year, date.d.month, date.d.date)
        .toString();
    },

    emitValues() {
      this.$emit("values", this.formValues);
    },
    convertDate(date) {
      if (momentjalaali(date, "jYYYY/jMM/jDD").isValid())
        return momentjalaali(date, "jYYYY/jMM/jDD").format("YYYY/MM/DD");
    },
  },
};
</script>
<style  >
.vue__time-picker {
  display: inline-block;
  position: relative;
  font-size: 1em;
  width: 100% !important;
  font-family: sans-serif;
  vertical-align: middle;
}

.vue__time-picker input.display-time {
  direction: initial !important;
  height: 35px !important;
  border-radius: 2px !important;
  border: 1px solid #d2d2d2 !important;
  width: 100% !important;
  padding: 0.3em 0.5em !important;
  font-size: 1em !important;
}

.vue__time-picker-dropdown,
.vue__time-picker .dropdown {
  direction: initial !important;
  position: absolute !important;
  z-index: 5 !important;
  top: calc(2.2em + 2px) !important;
  left: 0 !important;
  background: #fff !important;
  -webkit-box-shadow: 0 1px 6px rgb(0 0 0 / 15%) !important;
  box-shadow: 0 1px 6px rgb(0 0 0 / 15%) !important;
  width: 10em !important;
  height: 10em !important;
  font-weight: 400 !important;
  margin-top: 8px !important;
}

.styled-select {
  background-color: #fff !important;
  border: 1px solid #ced4da;
}

.pdp .pdp-group .pdp-icon {
  padding: 0.375rem 0.75rem;
  line-height: 1.5 !important;
  font-size: 14px !important;
  color: #495057;
  color: var(--text-color);
  background: #e9ecef;
  background: var(--icon-background);
  border: 1px solid #ced4da;
  border: 1px solid var(--border-color);
  display: none !important;
}

.pdp .pdp-group .pdp-input {
  display: block;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 14px !important;
  font-weight: 400;
  line-height: 1.5;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border: 1px solid var(--border-color);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  position: relative;
  flex: 1 1 auto;
}
.time-picker .vpd-actions{
  display: flex;
}
.time-picker .vpd-actions button{
        line-height: 15px;
      height: auto;
  }
</style>